import FeathersHelper from "../../helpers/feathers";

export const find = payload => FeathersHelper.find('rooms', payload);
export const create = payload => FeathersHelper.create('rooms', payload);
export const patch = (id, payload) => FeathersHelper.patch('rooms', id, payload);
export const remove = (id, params = {}) => FeathersHelper.remove('rooms', id, params);